module.exports = __webpack_public_path__ + "static/media/ideation-user-groups.578dd0ab.jpg";